export default class MathUtils {
    static round(value: number, digits: number) {         
        
        const numberOfDecimals = Math.pow(10, digits);
        return Math.round(value * numberOfDecimals) / numberOfDecimals;         
    }    
}